export const Status = [
  { label: '全部状态', value: -1 },
  { label: '开启', value: '1' },
  { label: '关闭', value: '0' }
]
export const Os = [
  { label: '全部操作系统', value: -1 },
  { label: 'Android', value: 1 },
  { label: 'iOS', value: 2 },
  { label: 'Windows', value: 3 },
  { label: '其他', value: 4 }
]
export const CarrierType = [{ label: '网站', value: '1' }]
export const Type = [
  { label: '手机', value: '1' },
  { label: '平板', value: '2' },
  { label: '电脑', value: '3' },
  { label: '智能电视', value: '4' },
  { label: '其他', value: '5' }
]
export const ShowPosition = [
  { label: '首屏', value: '1' },
  { label: '顶部', value: '2' },
  { label: '底部', value: '3' },
  { label: '侧边栏', value: '4' },
  { label: '未知', value: '5' }
]
export const ChargeType = [
  { label: 'CPM', value: 0 },
  { label: 'CPC', value: 1 },
  // { label: 'CPT', value: 2 }
]
export const UnitList = [
  { label: '全周期', value: 'full' },
  { label: '天', value: 'daily' },
  { label: '小时', value: 'hourly' }
]
export const IsCustomize = [
  { label: '不限定', value: 0 },
  { label: '自定义', value: 1 }
]
export const TimePeriod = [
  { label: '00:00-01:00', value: 0 },
  { label: '01:00-02:00', value: 1 },
  { label: '02:00-03:00', value: 2 },
  { label: '03:00-04:00', value: 3 },
  { label: '04:00-05:00', value: 4 },
  { label: '05:00-06:00', value: 5 },
  { label: '06:00-07:00', value: 6 },
  { label: '07:00-08:00', value: 7 },
  { label: '08:00-09:00', value: 8 },
  { label: '09:00-10:00', value: 9 },
  { label: '10:00-11:00', value: 10 },
  { label: '11:00-12:00', value: 11 },
  { label: '12:00-13:00', value: 12 },
  { label: '13:00-14:00', value: 13 },
  { label: '14:00-15:00', value: 14 },
  { label: '15:00-16:00', value: 15 },
  { label: '16:00-17:00', value: 16 },
  { label: '17:00-18:00', value: 17 },
  { label: '18:00-19:00', value: 18 },
  { label: '19:00-20:00', value: 19 },
  { label: '20:00-21:00', value: 20 },
  { label: '21:00-22:00', value: 21 },
  { label: '22:00-23:00', value: 22 },
  { label: '23:00-00:00', value: 23 }
]
export const AuditList = [
  { label: '全部审核状态', value: -1 },
  { label: '默认通过', value: '11' },
  { label: '待审核', value: '0' },
  { label: '审核通过', value: '1' },
  { label: '审核拒绝', value: '2' }
]
export const PageType = [
  { label: '纯曝光', value: '1' },
  { label: '跳转网页', value: '2' },
  { label: '下载应用', value: '3' },
  { label: '拨打电话', value: '4' }
]

export const YoulianghuiOS = [
  { label: 'Android', value: 1 },
  { label: 'iOS', value: 2 }
  // { label: 'H5', value: 3 }
]

export const scene = [
  { label: '信息流广告', value: 'FLOW' },
  { label: '详情页插入广告', value: 'FOCUS_POINT' },
  { label: '开屏广告', value: 'FLASH' },
  { label: '视频贴片广告', value: 'VIDEO_PASTE' },
  { label: '横幅广告', value: 'BANNER' },
  { label: '激励广告', value: 'REWARDED_VIDEO' }
  // { label: '插屏广告', value: 'INSERTION' }
]

export const adCrtTypeConst = [
  { label: '视频素材', value: 'VIDEO' },
  { label: '图文素材', value: 'IMAGE' },
  {
    label: '开屏:5-30秒长视频（9:16竖版素材）+首屏续播',
    value: 'FLASH_VIDEO_LONG'
  },
  { label: '开屏:图片（9:16竖版素材）', value: 'FLASH_IMAGE_V' },
  { label: '开屏:图片（16:9横版素材）', value: 'FLASH_IMAGE_H' },
  { label: '开屏:5s视频（9:16竖版素材）', value: 'FLASH_VIDEO_V' },
  { label: '开屏:5s视频（16:9横版素材）', value: 'FLASH_VIDEO_H' }
]

export const sceneCode = [
  {
    label: '信息流广告',
    value: 'FLOW',
    parentId: 0,
    selfRendering: [
      { label: '16：9图片/视频', value: 1 },
      { label: '9：16图片、9：16视频', value: 2 },
      { label: ' 16：9图片/视频、9：16视频', value: 3 },
      { label: '16：9图片/视频、3：2三小图', value: 4 },
      { label: '16：9图片', value: 5 },
      { label: '16：9图片，3：2三小图', value: 6 },
      { label: '9：16图片', value: 7 },
      { label: '16：9视频', value: 8 },
      { label: '9：16视频', value: 9 },
      { label: '16：9视频、9：16视频', value: 10 },
      { label: '16：9图片/视频、9：16图片/视频', value: 14 }
    ],
    children: [
      { label: '出现的第1条广告', value: 'FLOW_NORMAL_1', parentId: 'FLOW' },
      { label: '出现的第2条广告', value: 'FLOW_NORMAL_2', parentId: 'FLOW' },
      { label: '出现的第3条广告', value: 'FLOW_NORMAL_3', parentId: 'FLOW' },
      { label: '其他位置的广告', value: 'FLOW_NORMAL_0', parentId: 'FLOW' },
      { label: '出现的第1条广告', value: 'FLOW_IMMERSION_1', parentId: 'FLOW' },
      { label: '出现的第2条广告', value: 'FLOW_IMMERSION_2', parentId: 'FLOW' },
      { label: '出现的第3条广告', value: 'FLOW_IMMERSION_3', parentId: 'FLOW' },
      { label: '其他位置的广告', value: 'FLOW_IMMERSION_0', parentId: 'FLOW' }
    ]
  },
  {
    label: '详情页插入广告',
    value: 'FOCUS_POINT',
    parentId: 0,
    selfRendering: [
      { label: '16：9图片/视频', value: 1 },
      { label: '9：16图片、9：16视频', value: 2 },
      { label: ' 16：9图片/视频、9：16视频', value: 3 },
      { label: '16：9图片/视频、3：2三小图', value: 4 },
      { label: '16：9图片', value: 5 },
      { label: '16：9图片，3：2三小图', value: 6 },
      { label: '16：9视频', value: 8 },
      { label: '9：16视频', value: 9 },
      { label: '16：9视频、9：16视频', value: 10 }
    ],
    children: [
      {
        label: '详情页文中',
        value: 'INSERTION_DETAIL_MIDDLE',
        parentId: 'FOCUS_POINT'
      },
      {
        label: '详情页文末',
        value: 'INSERTION_DETAIL_TAIL',
        parentId: 'FOCUS_POINT'
      },
      {
        label: '详情页其他位置的广告',
        value: 'INSERTION_DETAIL_OTHER',
        parentId: 'FOCUS_POINT'
      }
    ]
  },
  {
    label: '开屏广告',
    value: 'FLASH',
    parentId: 0,
    templateRendering: [
      { label: '开屏', value: 'FLASH' },
      { label: '开屏V+', value: 'FLASH_V_PLUS' }
    ],
    children: [
      { label: '冷启动', value: 'FLASH_CODE', parentId: 'FLASH' },
      { label: '热启动', value: 'FLASH_HOT', parentId: 'FLASH' },
      { label: '不区分冷热启动', value: 'FLASH_OTHER', parentId: 'FLASH' }
    ]
  },
  {
    label: '视频贴片广告',
    value: 'VIDEO_PASTE',
    parentId: 0,
    selfRendering: [
      { label: '16：9图片/视频', value: 1 },
      { label: '9：16图片、9：16视频', value: 2 },
      { label: ' 16：9图片/视频、9：16视频', value: 3 },
      { label: '16：9图片/视频、3：2三小图', value: 4 },
      { label: '16：9图片', value: 5 },
      { label: '16：9图片，3：2三小图', value: 6 },
      { label: '9：16图片', value: 7 },
      { label: '16：9视频', value: 8 },
      { label: '9：16视频', value: 9 },
      { label: '16：9视频、9：16视频', value: 10 },
      { label: '16：9图片/视频、9：16图片/视频', value: 14 }
    ],
    children: [
      { label: '前贴', value: 'INSERTION_PASTE_HEAD', parentId: 'VIDEO_PASTE' },
      {
        label: '中贴',
        value: 'INSERTION_PASTE_MIDDLE',
        parentId: 'VIDEO_PASTE'
      },
      { label: '后贴', value: 'INSERTION_PASTE_TAIL', parentId: 'VIDEO_PASTE' },
      {
        label: '暂停贴',
        value: 'INSERTION_PASTE_PAUSE',
        parentId: 'VIDEO_PASTE'
      }
    ]
  },
  {
    label: '横幅广告',
    value: 'BANNER',
    parentId: 0,
    selfRendering: [{ label: '16:9图片，9：16图片', value: 11 }],
    children: [
      { label: '固定在页面顶部', value: 'FOCUS_POINT_TOP', parentId: 'BANNER' },
      {
        label: '固定在页面中部',
        value: 'FOCUS_POINT_MIDDLE',
        parentId: 'BANNER'
      },
      {
        label: '固定在页面底部',
        value: 'FOCUS_POINT_BOTTOM',
        parentId: 'BANNER'
      },
      {
        label: '固定在其他位置的广告',
        value: 'FOCUS_POINT_OTHER',
        parentId: 'BANNER'
      }
    ]
  },
  {
    label: '激励广告',
    value: 'REWARDED_VIDEO',
    parentId: 0,
    templateRendering: [
      { label: '激励视频+激励浏览', value: 'ALL_DIRECTION' },
      { label: '激励浏览', value: 'IMAGE' },
      { label: '激励视频', value: 'VIDEO' }
    ],
    children: [
      {
        label: '登陆奖励：每日登陆、打卡奖励',
        value: 'REWARDED_APP_LOGIN',
        parentId: 'REWARDED_VIDEO'
      },
      {
        label: '过关奖励：过关、通关加倍',
        value: 'REWARDED_APP_PASS',
        parentId: 'REWARDED_VIDEO'
      },
      {
        label: '线索提示：获得提示、生命复活 / 恢复',
        value: 'REWARDED_APP_TIPS',
        parentId: 'REWARDED_VIDEO'
      },
      {
        label: '任务奖励：完成应用内指定任务',
        value: 'REWARDED_APP_TASK',
        parentId: 'REWARDED_VIDEO'
      },
      {
        label: '价值奖励：限时解锁、功能试用',
        value: 'REWARDED_APP_TRY',
        parentId: 'REWARDED_VIDEO'
      },
      {
        label: '兑换奖励：兑换应用内虚拟货币、付费功能',
        value: 'REWARDED_APP_COINS',
        parentId: 'REWARDED_VIDEO'
      },
      {
        label: '其他奖励：其他类型奖励',
        value: 'REWARDED_APP_OTHER',
        parentId: 'REWARDED_VIDEO'
      }
    ]
    // },
    // {
    //   label: '插屏广告',
    //   value: 'INSERTION',
    //   parentId: 0,
    //   templateRendering: [
    //     { label: '横版插屏', value: 'INLINE_H' },
    //     { label: '横/竖版插屏', value: 'INLINE_VH' },
    //     { label: '全屏插屏', value: 'INLINE_FULL' },
    //     { label: '半屏插屏-竖版', value: 'INLINE_V' }
    //   ],
    //   children: [
    //     { label: '插屏', value: 'INSERTION_INSERTION', parentId: 'INSERTION' }
    //   ]
  }
]

export const appMarket = {
  1: [
    {
      id: 1000,
      name: '应用宝',
      deleteStatus: 0,
      urls: [
        { url: 'https://android.myapp.com/', enabled: 1 },
        { url: 'https://sj.qq.com/', enabled: 1 },
        { url: 'http://sj.qq.com/', enabled: 1 },
        { url: 'http://app.qq.com/', enabled: 1 },
        { url: 'https://a.app.qq.com/', enabled: 1 },
        { url: 'https://webcdn.m.qq.com/', enabled: 1 }
      ],
      downloadUrls: []
    },
    {
      id: 2,
      name: '小米应用商店',
      deleteStatus: 0,
      urls: [
        { url: 'http://app.mi.com/', enabled: 1 },
        { url: 'https://app.mi.com/', enabled: 1 },
        { url: 'http://app.xiaomi.com/', enabled: 1 }
      ],
      downloadUrls: []
    },
    {
      id: 3,
      name: '豌豆荚',
      deleteStatus: 0,
      urls: [{ url: 'https://www.wandoujia.com/', enabled: 1 }],
      downloadUrls: []
    },
    {
      id: 4,
      name: 'Google play Store',
      deleteStatus: 0,
      urls: [{ url: 'https://play.google.com/', enabled: 1 }],
      downloadUrls: []
    },
    {
      id: 5,
      name: '魅族应用商店',
      deleteStatus: 0,
      urls: [
        { url: 'https://app.flyme.cn/', enabled: 1 },
        { url: 'https://app.meizu.com/', enabled: 1 },
        { url: 'http://app.meizu.com/', enabled: 1 },
        { url: 'https://game.flyme.cn/', enabled: 1 }
      ],
      downloadUrls: []
    },
    {
      id: 6,
      name: '360手机助手',
      deleteStatus: 0,
      urls: [{ url: 'http://zhushou.360.cn/', enabled: 1 }],
      downloadUrls: []
    },
    {
      id: 7,
      name: '百度应用商店',
      deleteStatus: 0,
      urls: [
        { url: 'https://shouji.baidu.com/', enabled: 1 },
        { url: 'https://mobile.baidu.com/', enabled: 1 }
      ],
      downloadUrls: []
    },
    {
      id: 8,
      name: '华为应用市场',
      deleteStatus: 0,
      urls: [
        { url: 'http://appstore.huawei.com/', enabled: 1 },
        { url: 'https://appstore.huawei.com/', enabled: 1 },
        { url: 'http://a.vmall.com/', enabled: 1 },
        { url: 'http://app.hicloud.com/', enabled: 1 },
        { url: 'https://appgallery.huawei.com/', enabled: 1 },
        { url: 'https://appgallery1.huawei.com/', enabled: 1 }
      ],
      downloadUrls: []
    },
    {
      id: 9,
      name: '九游',
      deleteStatus: 0,
      urls: [
        { url: 'http://www.9game.cn/', enabled: 1 },
        { url: 'https://www.9game.cn/', enabled: 1 },
        { url: 'http://a.9game.cn/', enabled: 1 },
        { url: 'https://a.9game.cn/', enabled: 1 }
      ],
      downloadUrls: []
    },
    {
      id: 10,
      name: 'TapTap',
      deleteStatus: 0,
      urls: [{ url: 'https://www.taptap.com/', enabled: 1 }],
      downloadUrls: []
    },
    {
      id: 11,
      name: '金立游戏大厅',
      deleteStatus: 0,
      urls: [
        { url: 'http://game.gionee.com/', enabled: 1 },
        { url: 'https://www.anzhuoapk.com/', enabled: 1 }
      ],
      downloadUrls: []
    },
    {
      id: 12,
      name: '小米游戏',
      deleteStatus: 0,
      urls: [
        { url: 'http://game.xiaomi.com/', enabled: 1 },
        { url: 'https://game.wali.com/', enabled: 1 }
      ],
      downloadUrls: []
    },
    {
      id: 13,
      name: 'OPPO软件商店',
      deleteStatus: 0,
      urls: [
        { url: 'http://m.store.oppomobile.com/', enabled: 1 },
        { url: 'https://app.cdo.oppomobile.com/', enabled: 1 },
        { url: 'http://adsfs.oppomobile.com/', enabled: 1 },
        { url: 'http://store.oppomobile.com/', enabled: 0 },
        { url: 'https://storedl1.nearme.com.cn/', enabled: 1 },
        { url: 'https://storedl.nearme.com.cn/', enabled: 1 },
        { url: 'https://adsfs.heytapimage.com/', enabled: 1 }
      ],
      downloadUrls: []
    },
    {
      id: 14,
      name: 'VIVO应用商店',
      deleteStatus: 0,
      urls: [
        { url: 'http://info.appstore.vivo.com.cn/', enabled: 1 },
        { url: 'https://game.vivo.com.cn/', enabled: 1 },
        { url: 'https://h5coml.vivo.com.cn/', enabled: 1 }
      ],
      downloadUrls: []
    },
    {
      id: 15,
      name: '联想乐商店',
      deleteStatus: 0,
      urls: [
        { url: 'http://www.lenovomm.com/', enabled: 1 },
        { url: 'https://www.lenovomm.com/', enabled: 1 },
        { url: 'http://3g.lenovomm.com/', enabled: 1 },
        { url: 'https://3g.lenovomm.com/', enabled: 1 }
      ],
      downloadUrls: []
    },
    {
      id: 16,
      name: '金立软件商店',
      deleteStatus: 0,
      urls: [
        { url: 'http://www.anzhuoapk.com/', enabled: 1 },
        { url: 'http://www.appgionee.com/', enabled: 1 },
        { url: 'http://m.appgionee.com/', enabled: 1 }
      ],
      downloadUrls: []
    },
    {
      id: 17,
      name: '酷派应用商店',
      deleteStatus: 0,
      urls: [{ url: 'http://www.coolmart.net.cn/', enabled: 1 }],
      downloadUrls: []
    },
    {
      id: 18,
      name: '移动MM',
      deleteStatus: 0,
      urls: [
        { url: 'http://mm.10086.cn/', enabled: 1 },
        { url: 'http://mm.10086.mmarket.com/', enabled: 1 },
        { url: 'http://g.10086.cn/', enabled: 1 },
        { url: 'http://a.10086.cn/', enabled: 1 }
      ],
      downloadUrls: []
    },
    {
      id: 19,
      name: '安智',
      deleteStatus: 0,
      urls: [
        { url: 'http://www.anzhi.com/', enabled: 1 },
        { url: 'http://m.anzhi.com/', enabled: 1 }
      ],
      downloadUrls: []
    },
    {
      id: 20,
      name: 'PP助手',
      deleteStatus: 0,
      urls: [
        { url: 'https://www.25pp.com/', enabled: 1 },
        { url: 'https://m.pp.cn/', enabled: 1 },
        { url: 'https://wap.25pp.com/', enabled: 1 }
      ],
      downloadUrls: []
    },
    {
      id: 21,
      name: '酷安',
      deleteStatus: 0,
      urls: [{ url: 'https://www.coolapk.com/', enabled: 1 }],
      downloadUrls: []
    },
    {
      id: 22,
      name: '卓易市场',
      deleteStatus: 0,
      urls: [{ url: 'http://market.droi.com/', enabled: 1 }],
      downloadUrls: []
    },
    {
      id: 23,
      name: '安卓市场',
      deleteStatus: 1,
      urls: [{ url: 'http://apk.hiapk.com/', enabled: 0 }],
      downloadUrls: []
    },
    {
      id: 24,
      name: '91助手',
      deleteStatus: 1,
      urls: [{ url: 'http://apk.91.com/', enabled: 0 }],
      downloadUrls: []
    },
    {
      id: 25,
      name: '机锋市场',
      deleteStatus: 1,
      urls: [{ url: 'http://apk.gfan.com/', enabled: 0 }],
      downloadUrls: []
    },
    {
      id: 26,
      name: '天翼空间',
      deleteStatus: 1,
      urls: [{ url: 'http://wap.189store.com/', enabled: 0 }],
      downloadUrls: []
    },
    {
      id: 27,
      name: '4399',
      deleteStatus: 0,
      urls: [{ url: 'http://a.4399.cn/', enabled: 1 }],
      downloadUrls: []
    },
    {
      id: 28,
      name: '好游快爆',
      deleteStatus: 0,
      urls: [{ url: 'https://www.3839.com/', enabled: 1 }],
      downloadUrls: []
    },
    {
      id: 29,
      name: '应用汇',
      deleteStatus: 0,
      urls: [{ url: 'http://www.appchina.com/', enabled: 1 }],
      downloadUrls: []
    },
    {
      id: 30,
      name: '2345手机助手',
      deleteStatus: 0,
      urls: [
        { url: 'http://zhushou.2345.com/', enabled: 1 },
        { url: 'https://zhushou.2345.com/', enabled: 1 }
      ],
      downloadUrls: []
    },
    {
      id: 31,
      name: '搜狗',
      deleteStatus: 0,
      urls: [{ url: 'http://zhushou.sogou.com/', enabled: 1 }],
      downloadUrls: []
    },
    {
      id: 32,
      name: 'bilibili游戏中心',
      deleteStatus: 0,
      urls: [{ url: 'https://www.biligame.com/', enabled: 1 }],
      downloadUrls: []
    },
    { id: 33, name: '其他', deleteStatus: 0, urls: [], downloadUrls: [] }
  ],
  2: [
    {
      id: 1001,
      name: 'App Store',
      deleteStatus: 0,
      urls: [
        { url: 'https://itunes.apple.com/', enabled: 0 },
        { url: 'http://apps.apple.com/', enabled: 1 },
        { url: 'https://apps.apple.com/', enabled: 1 }
      ],
      downloadUrls: []
    },
    { id: 101, name: '其他', deleteStatus: 0, urls: [], downloadUrls: [] }
  ]
}

export const disableOrNot = [
  { value: 0, label: '正常' },
  { value: 1, label: '停用', type: 'danger' },
  { value: 2, label: '删除', type: 'warning' }
]
export const reviewStatus = [
  { value: '', label: '全部' },
  { value: 0, label: '未审核', type: 'info' },
  { value: 1, label: '审核通过', type: 'success' },
  { value: 2, label: '审核不通过', type: 'danger' },
  { value: 99, label: '未送审', type: 'warning' }
]
export const materialReviewSstatus = [
  { value: '', label: '全部' },
  { value: 0, label: '未审核', type: 'info' },
  { value: 1, label: '审核中' },
  { value: 2, label: '审核通过', type: 'success' },
  { value: 3, label: '驳回', type: 'danger' },
  { value: 4, label: '停用', type: 'warning' },
  { value: 99, label: '未送审', type: 'warning' }
]
export const resourceStatus = [
  { value: 0, label: '启用' },
  { value: 1, label: '停用', type: 'danger' }
]

export const BaiduOption = [
  {
    label: '信息流广告-0',
    value: 0,
    children: [
      {
        label: '小图',
        value: 'SIMG',
        disabled: false,
        children: [
          {
            label: '3:2',
            value: 'RATIO_3X2'
          },
          {
            label: '4:3',
            value: 'RATIO_4X3'
          },
        ]
      },
      {
        label: '大图',
        value: 'BIMG',
        disabled: false,
        children: [
          {
            label: '2:1',
            value: 'RATIO_2X1'
          },
          {
            label: '16:9',
            value: 'RATIO_16X9'
          },
        ]
      },
      {
        label: '组图',
        value: 'GIMG',
        disabled: false,
        children: [
          {
            label: '3:2',
            value: 'RATIO_3X2'
          },
        ]
      },
      {
        label: '视频',
        value: 'VIO',
        disabled: false,
        children: [
          {
            label: '16:9',
            value: 'RATIO_16X9'
          },
          {
            label: '9:16',
            value: 'RATIO_9X16'
          },
        ]
      }
    ]
  },
  {
    label: '开屏广告-3',
    value: 3,
    children: [
      {
        label: '大图',
        value: 'BIMG',
        children: [
          {
            label: '9:16',
            value: 'RATIO_9X16'
          },
          {
            label: '2:3',
            value: 'RATIO_2X3'
          },
        ]
      }
    ]
  },
  {
    label: '激励视频广告-4',
    value: 4,
    children: [
      {
        label: '激励视频',
        value: 'RVID',
        children: [
          {
            label: '16:9',
            value: 'RATIO_16X9'
          },
          {
            label: '9:16',
            value: 'RATIO_9X16'
          },
        ]
      }
    ]
  },
  {
    label: '插屏-6',
    value: 6,
    children: [
      {
        label: '小图',
        value: 'SIMG',
        children: [
          {
            label: '3:2',
            value: '3:2'
          },
        ]
      },
      {
        label: '大图',
        value: 'BIMG',
        children: [
          {
            label: '2:1',
            value: 'RATIO_2X1'
          },
          {
            label: '16:9',
            value: 'RATIO_16X9'
          },
          {
            label: '9:16',
            value: 'RATIO_2X1'
          },
          {
            label: '2:3',
            value: 'RATIO_3X1'
          },
        ]
      },
      {
        label: '视频',
        value: 'VIO',
        children: [
          {
            label: '16:9',
            value: 'RATIO_16X9'
          },
          {
            label: '9:16',
            value: 'RATIO_9X16'
          },
        ]
      }
    ]
  },
]

export const csjOption = [
  {
    label: '单图',
    value: 1,
    children: [
      {
        label: '1080*1920',
        value: '1080*1920',
      },
      {
        label: '600*600',
        value: '600*600',
      },
      {
        label: '600*500',
        value: '600*500',
      },
      {
        label: '240*180',
        value: '240*180',
      },
      {
        label: '720*480',
        value: '720*480',
      },
      {
        label: '456*300',
        value: '456*300',
      },
      {
        label: '320*210',
        value: '320*210',
      },
      {
        label: '333*200',
        value: '333*200',
      },
      {
        label: '720*405',
        value: '720*405',
      },
      {
        label: '1280*720',
        value: '1280*720',
      },
      {
        label: '1200*627',
        value: '1200*627',
      },
      {
        label: '640*330',
        value: '640*330',
      },
      {
        label: '640*320',
        value: '640*320',
      },
      {
        label: '640*264',
        value: '640*264',
      },
      {
        label: '720*240',
        value: '720*240',
      },
      {
        label: '1080*170',
        value: '1080*170',
      },
      {
        label: '640*100',
        value: '640*100',
      },
      {
        label: '1080*1620',
        value: '1080*1620',
      }
    ]
  },
  {
    label: '组图',
    value: 2,
    children: [
      {
        label: '240*180',
        value: '240*180',
      },
      {
        label: '456*300',
        value: '456*300',
      },
      {
        label: '320*210',
        value: '320*210',
      },
      {
        label: '324*210',
        value: '324*210',
      }
    ]
  },
  {
    label: '视频',
    value: 3,
    children: [
      {
        label: '720*405',
        value: '720*405',
      },
      {
        label: '1280*720',
        value: '1280*720',
      },
      {
        label: '720*1280',
        value: '720*1280',
      },
      {
        label: '1080*1920',
        value: '1080*1920',
      },
      {
        label: '360*640',
        value: '360*640',
      },
      {
        label: '1440*2560',
        value: '1440*2560',
      },
      {
        label: '2160*3840',
        value: '2160*3840',
      },
      {
        label: '1920*1080',
        value: '1920*1080',
      },
      {
        label: '2560*1440',
        value: '2560*1440',
      },
      {
        label: '3840*2160',
        value: '3840*2160',
      },
      {
        label: '640*360',
        value: '640*360',
      },
      {
        label: '1080*1620',
        value: '1080*1620',
      }
    ]
  }
]

export const transformationType = [
  { type: 'huawei', label: '激活', value: 'activate' },
  { type: 'huawei', label: '注册', value: 'register' },
  { type: 'huawei', label: '次留', value: 'retain' },
  { type: 'huawei', label: '付费', value: 'paid' },
  { type: 'huawei', label: '浏览', value: 'browse' },
  { type: 'huawei', label: '收藏', value: 'collection' },
  { type: 'huawei', label: '下单', value: 'preOrder' },
  { type: 'huawei', label: '订阅', value: 'subscribe' },
  { type: 'huawei', label: '登陆', value: 'login' },
  { type: 'huawei', label: '更新', value: 'update' },
  { type: 'huawei', label: '预约服务', value: 'reservation' },
  { type: 'huawei', label: '加入购物车', value: 'addToCart' },
  { type: 'huawei', label: '3日留存', value: 'threeDayRetain' },
  { type: 'huawei', label: '7日留存', value: 'sevenDayRetain' },
  { type: 'huawei', label: '订单发货', value: 'deliver' },
  { type: 'huawei', label: '订单签收', value: 'orderSigning' },
  { type: 'huawei', label: '首次购买', value: 'firstPurchase' },
  { type: 'huawei', label: '购买会员', value: 'purchaseMemberCard' },
  { type: 'huawei', label: '快应用添加', value: 'addQuickApp' },
  { type: 'huawei', label: '添加到心愿清单', value: 'addToWishlist' },
  { type: 'huawei', label: '从推送通知打开', value: 'openedFromPushNotification' },
  { type: 'huawei', label: '用户唤醒', value: 'reEngage' },
  { type: 'huawei', label: '表单提交', value: 'form_submit' },
  { type: 'huawei', label: '有效咨询', value: 'consult' },
  { type: 'huawei', label: '有效线索-表单', value: 'effectiveLeadsForm' },
  { type: 'huawei', label: '潜在客户线索-表单', value: 'potentialCustomerForm' },
  { type: 'huawei', label: '有效获客', value: 'custom_acquisit' },
  { type: 'huawei', label: '有效预定', value: 'book' },
  { type: 'huawei', label: '网页咨询', value: 'consultOnline' },
  { type: 'huawei', label: '有效线索-咨询', value: 'effectiveLeadsOnline' },
  { type: 'huawei', label: '潜在客户线索-咨询', value: 'potentialCustomerOnline' },
  { type: 'huawei', label: '电话直拨', value: 'phoneDialing' },
  { type: 'huawei', label: '有效线索-电话', value: 'effectiveLeadsPhone' },
  { type: 'huawei', label: '潜在客户线索-电话', value: 'potentialCustomerPhone' },
  { type: 'huawei', label: '扫码关注', value: 'followScan' },
  { type: 'huawei', label: '抽奖线索', value: 'leadsLottery' },
  { type: 'huawei', label: '添加付款信息', value: 'addPaymentInfo' },
  { type: 'huawei', label: '开始试用', value: 'startTrial' },
  { type: 'huawei', label: '发起结账', value: 'initiatedCheckout' },
  { type: 'huawei', label: '邀请', value: 'invite' },
  { type: 'huawei', label: '搜索', value: 'search' },
  { type: 'huawei', label: '分享', value: 'share' },
  { type: 'huawei', label: '旅行预订', value: 'travelBooking' },
  { type: 'huawei', label: '评级', value: 'rate' },
  { type: 'huawei', label: '内容视图', value: 'contentView' },
  { type: 'huawei', label: '自定义（应用）', value: 'custom' },
  { type: 'huawei', label: '自定义（网页）', value: 'custom_ landingpage' },
  { type: 'huawei', label: '落地页内按钮点击', value: 'landingpageClick' },
  { type: 'huawei', label: '卡券领取', value: 'coupon' },
  { type: 'huawei', label: '门店导航', value: 'navigate' },
  { type: 'huawei', label: '抽奖', value: 'lottery' },
  { type: 'huawei', label: '投票', value: 'vote' },
  { type: 'huawei', label: '页面跳转', value: 'redirect' },
  { type: 'huawei', label: '礼包兑换', value: 'gamePackageRedemption' },
  { type: 'huawei', label: '礼包领取', value: 'gamePackageClaiming' },
  { type: 'huawei', label: '游戏内创建角色', value: 'createRole' },
  { type: 'huawei', label: '游戏授权', value: 'authorize' },
  { type: 'huawei', label: '游戏完成新手教程', value: 'tutorialCompletion' },
  { type: 'huawei', label: '解锁成就', value: 'achievementUnlocked' },
  { type: 'huawei', label: '花掉积分', value: 'spentCredits' },
  { type: 'huawei', label: '达到级别', value: 'levelAchieved' },
  { type: 'huawei', label: '完件', value: 'loanCompletion' },
  { type: 'huawei', label: '预授信', value: 'preCredit' },
  { type: 'huawei', label: '授信', value: 'credit' },
  { type: 'huawei', label: '关注', value: 'follow' },
  { type: 'huawei', label: '转发', value: 'forward' },
  { type: 'huawei', label: '阅读', value: 'read' },
  { type: 'huawei', label: '点赞', value: 'like' },
  { type: 'huawei', label: '评论', value: 'comment' },
  { type: 'huawei', label: '优质激活', value: 'qualityActivate' },
  { type: 'qutoutiao', label: '激活', value: 0 },
  { type: 'qutoutiao', label: '注册', value: 1 },
  { type: 'qutoutiao', label: '首次付费', value: 2 },
  { type: 'qutoutiao', label: '其他', value: 5 },
  { type: 'qutoutiao', label: '次留(T1)', value: 6 },
  { type: 'qutoutiao', label: '复制报名', value: 7 },
  { type: 'qutoutiao', label: '首次拉活', value: 8 },
  { type: 'qutoutiao', label: '表单提交', value: 26 },
  { type: 'qutoutiao', label: '有效咨询', value: 28 },
  { type: 'qutoutiao', label: '表单提交（小程序）', value: 29 },
  { type: 'qutoutiao', label: '有效阅读', value: 30 },
  { type: 'qutoutiao', label: '快应用添加至桌面', value: 32 },
  { type: 'qutoutiao', label: '公众号内付费', value: 34 },
  { type: 'qutoutiao', label: '关键行为', value: 35 },
  { type: 'qutoutiao', label: '二留(T2)', value: 36 },
  { type: 'qutoutiao', label: '三留(T3)', value: 37 },
  { type: 'qutoutiao', label: '四留(T4)', value: 38 },
  { type: 'qutoutiao', label: '五留(T5)', value: 39 },
  { type: 'qutoutiao', label: '六留(T6)', value: 40 },
  { type: 'qutoutiao', label: '七留(T7)', value: 41 },
  { type: 'qutoutiao', label: '跳转小程序', value: 44 },
  { type: 'qutoutiao', label: '深度注册', value: 47 },
  { type: 'qutoutiao', label: '播放时长', value: 48 },
  { type: 'qutoutiao', label: '播放次数', value: 49 },
  { type: 'qutoutiao', label: '完播率', value: 50 },
  { type: 'honor', label: '激活', value: 10001 },
  { type: 'honor', label: '注册', value: 10002 },
  { type: 'honor', label: '次留', value: 10003 },
  { type: 'honor', label: '付费', value: 10004 },
  { type: 'honor', label: '浏览', value: 10005 },
  { type: 'honor', label: '收藏', value: 10006 },
  { type: 'honor', label: '下单', value: 10007 },
  { type: 'honor', label: '订阅', value: 10008 },
  { type: 'honor', label: '登陆', value: 10009 },
  { type: 'honor', label: '更新', value: 10010 },
  { type: 'honor', label: '预约服务', value: 10011 },
  { type: 'honor', label: '加入购物车', value: 10012 },
  { type: 'honor', label: '转化及生命周期3日留存', value: 10013 },
  { type: 'honor', label: '转化及生命周期7日留存', value: 10014 },
  { type: 'honor', label: '订单发货', value: 10015 },
  { type: 'honor', label: '订单签收', value: 100016 },
  { type: 'honor', label: '首次购买', value: 10017 },
  { type: 'honor', label: '购买会员', value: 10018 },
  { type: 'honor', label: '快应用添加', value: 10019 },
  { type: 'honor', label: '添加到心愿清单', value: 10020 },
  { type: 'honor', label: '从推送通知打开', value: 10021 },
  { type: 'honor', label: '用户唤醒', value: 10022 },
  { type: 'honor', label: '媒体变现曝光', value: 10023 },
  { type: 'honor', label: '媒体变现点击', value: 10024 },
  { type: 'honor', label: '当日付费', value: 10025 },
  { type: 'honor', label: '有效咨询', value: 20001 },
  { type: 'honor', label: '表单提交', value: 20002 },
  { type: 'honor', label: '有效线索-表单', value: 20003 },
  { type: 'honor', label: '潜在客户线索-表单', value: 20004 },
  { type: 'honor', label: '有效获客', value: 20005 },
  { type: 'honor', label: '有效预定', value: 20006 },
  { type: 'honor', label: '应用打开', value: 30001 },
  { type: 'honor', label: '网页咨询', value: 40001 },
  { type: 'honor', label: '有效线索-咨询', value: 40002 },
  { type: 'honor', label: '潜在客户线索-咨询', value: 40003 },
  { type: 'honor', label: '电话直拨', value: 40004 },
  { type: 'honor', label: '有效线索-电话', value: 40005 },
  { type: 'honor', label: '潜在客户线索-电话', value: 40006 },
  { type: 'honor', label: '扫码关注', value: 50001 },
  { type: 'honor', label: '抽奖线索', value: 50002 },
  { type: 'honor', label: '添加付款信息', value: 50003 },
  { type: 'honor', label: '开始试用', value: 50004 },
  { type: 'honor', label: '发起结账', value: 50005 },
  { type: 'honor', label: '邀请', value: 50006 },
  { type: 'honor', label: '搜索', value: 50007 },
  { type: 'honor', label: '分享', value: 50008 },
  { type: 'honor', label: '旅行预订', value: 50009 },
  { type: 'honor', label: '评级', value: 50010 },
  { type: 'honor', label: '内容视图', value: 50011 },
  { type: 'honor', label: '自定义（应用）', value: 50012 },
  { type: 'honor', label: '自定义（网页）', value: 50013 },
  { type: 'honor', label: '落地页内按钮点击', value: 60001 },
  { type: 'honor', label: '卡券领取', value: 60002 },
  { type: 'honor', label: '门店导航', value: 60003 },
  { type: 'honor', label: '抽奖', value: 60004 },
  { type: 'honor', label: '投票', value: 60005 },
  { type: 'honor', label: '页面跳转', value: 60006 },
  { type: 'honor', label: '礼包兑换', value: 70001 },
  { type: 'honor', label: '礼包领取', value: 70002 },
  { type: 'honor', label: '创建角色', value: 70003 },
  { type: 'honor', label: '游戏授权', value: 70004 },
  { type: 'honor', label: '完成新手教程', value: 70005 },
  { type: 'honor', label: '解锁成就', value: 70006 },
  { type: 'honor', label: '花掉积分', value: 70007 },
  { type: 'honor', label: '达到级别', value: 70008 },
  { type: 'honor', label: '完件', value: 80001 },
  { type: 'honor', label: '预授信', value: 80002 },
  { type: 'honor', label: '授信', value: 80003 },
  { type: 'honor', label: '关注', value: 90001 },
  { type: 'honor', label: '转发', value: 90002 },
  { type: 'honor', label: '阅读', value: 90003 },
  { type: 'honor', label: '点赞', value: 90004 },
  { type: 'honor', label: '评论', value: 90005 },
  { type: 'honor', label: '次日留存', value: 100001 },
  { type: 'honor', label: '应用留存3日留存', value: 100002 },
  { type: 'honor', label: '应用留存7日留存', value: 100003 },
  { type: 'emi', label: '自定义激活', value: 'APP_ACTIVE' },
  { type: 'emi', label: '自定义注册', value: 'APP_REGISTER' },
  { type: 'emi', label: '自定义新增激活', value: 'APP_ACTIVE_NEW' },
  { type: 'emi', label: '首次拉活', value: 'APP_RE_ACTIVE' },
  { type: 'emi', label: '付费', value: 'APP_PAY' },
  { type: 'emi', label: '首次付费', value: 'APP_FIRST_PAY' },
  { type: 'emi', label: '留存', value: 'APP_RETENTION' },
  { type: 'emi', label: '购买', value: 'APP_PURCHASE' },
  { type: 'emi', label: '召回', value: 'APP_UNINSTALL' },
  { type: 'emi', label: '拉活', value: 'APP_RE_ACTIVE_WAKE_UP' },
  { type: 'emi', label: '首单购买', value: 'APP_NEW_USER_PURCHASE' },
  { type: 'emi', label: 'IPVUV', value: 'APP_IPVUV' },
  { type: 'emi', label: '关键行为', value: 'APP_ADDICTION' },
  { type: 'emi', label: '商详页浏览', value: 'APP_VIEW_CONTENT' },
  { type: 'emi', label: '加购', value: 'ADD_CART' },
  { type: 'emi', label: '下单', value: 'APP_COMPLETE_ORDER' },
  { type: 'emi', label: '授信', value: 'APP_CREDIT' },
  { type: 'emi', label: '完件', value: 'APP_SUBMIT' },
  { type: 'emi', label: '付费金额', value: 'APP_PAY_AMOUNT' },
  { type: 'emi', label: '加桌（仅快应用投放使用）', value: 'APP_ADD_DESKTOP' },
  { type: 'emi', label: '开户', value: 'APP_START_OPEN_ACCOUNT' },
  { type: 'emi', label: '打开中间页', value: 'APP_OPEN_MIDDLE_PAGE' },
  { type: 'emi', label: '打开店铺页', value: 'APP_OPEN_SHOP_PAGE' },
  { type: 'emi', label: '店铺下单', value: 'APP_SHOP_ORDER' },
  { type: 'emi', label: '线索', value: 'APP_INQUIRE' },
  { type: 'emi', label: '自定义3日留存', value: 'APP_RETENTION_3D' },
  { type: 'emi', label: '自定义4日留存', value: 'APP_RETENTION_4D' },
  { type: 'emi', label: '自定义5日留存', value: 'APP_RETENTION_5D' },
  { type: 'emi', label: '自定义6日留存', value: 'APP_RETENTION_6D' },
  { type: 'emi', label: '自定义7日留存', value: 'APP_RETENTION_7D' },
  { type: 'lianxiang', label: '点击后', value: 'click' },
  { type: 'lianxiang', label: '曝光后', value: 'show' },
]